import firebase from 'firebase';
import { firebaseApp } from '../../data/config';

export const facebookProvider = new firebase.auth.FacebookAuthProvider();

const facebookAuth = async (onSuccess, onFail) => {
  try {
    firebaseApp
      .auth()
      .signInWithPopup(facebookProvider)
      .then((result) => {
        onSuccess(onSuccess(result.user));
      });
  } catch (error) {
    onFail(error);
  }
};

export default facebookAuth;
